import LinearProgressBar from './linearProgressBar/LinearProgressBar'

const LinearProgress = ({ progress, timing }) => {

    return <LinearProgressBar progress={progress} timing={timing} />

}

export default LinearProgress